/* One-tap add to cart for MindMorn product cards. Adds through Horizon's CartLinesUpdateEvent so
   the cart drawer opens; falls back to /cart when the drawer is not on the page. */
(() => {
  if (window.mmCardsReady) return;
  window.mmCardsReady = true;
  const ROOT = window.Shopify?.routes?.root || '/';

  const post = (body) => fetch(`${ROOT}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((r) => r.json()).then((j) => { if (j.status) throw j; return j; });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mm-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const label = btn.querySelector('[data-label]') || btn;
    const original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding';
    const items = [{ id: +btn.dataset.mmQuickAdd, quantity: 1 }];
    try {
      const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
      let ev = null;
      try { ev = await import('@shopify/events'); } catch (err) { ev = null; }
      if (!ev || !ids.length) {
        await post({ items });
        location.href = `${ROOT}cart`;
        return;
      }
      const d = ev.CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new ev.CartLinesUpdateEvent({
        action: 'add', context: 'product', promise: d.promise,
        lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      }));
      const settle = async (sections, failed) => {
        const cart = await fetch(`${ROOT}cart.js`).then((r) => r.json());
        d.resolve({
          cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'mm-card', sourceId: 'mm-card', itemCount: 1, sections, didError: failed },
        });
      };
      try {
        const res = await post({ items, sections: ids.join(',') });
        await settle(res.sections, false);
      } catch (err) {
        await settle(undefined, true);
        throw err;
      }
      label.textContent = 'Added';
      setTimeout(() => { label.textContent = original; }, 1500);
    } catch (err) {
      label.textContent = 'Try again';
      setTimeout(() => { label.textContent = original; }, 2000);
    } finally {
      btn.disabled = false;
    }
  });
})();
